import styled from 'styled-components';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  backdrop-filter: blur(4px);
  z-index: ${props => themeGet('zIndices.4')(props)};

  display: flex;
  justify-content: center;
  align-items: center;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    background-color: ${getPaletteColor('background.lighter')};
    opacity: 0.7;
    position: absolute;
    z-index: -1;
  }
`;